function birthDateMask(value) {
  let len;
  let val;
  let result;
  if (value) {
    val = value.toString().replace(/\D/g, '');
    len = val.length;

    if (len <= 2) {
      result = `${val.substr(0, 2)}`;
    }
    if (len > 2 && len <= 4) {
      result = `${val.substr(0, 2)}/${val.substr(2, 4)}`;
    }
    if (len > 4) {
      result = `${val.substring(0, 2)}/${val.substring(2, 4)}/${val.substring(4, 8)}`;
    }
  }

  return result;
}
export default birthDateMask;
